const NAMESPACE = "location";

const KEYS = {
    latitudeLabel: "latitudeLabel",
    longitudeLabel: "longitudeLabel",
    latitudeMaxLengthErrorMsg: "latitudeMaxLengthErrorMsg",
    latitudeMinLengthErrorMsg: "latitudeMinLengthErrorMsg",
    longitudeMaxLengthErrorMsg: "longitudeMaxLengthErrorMsg",
    longitudeMinLengthErrorMsg: "longitudeMinLengthErrorMsg",
    longitudeLocationCompleteErrorMsg: "longitudeLocationCompleteErrorMsg",
    latitudeLocationCompleteErrorMsg: "latitudeLocationCompleteErrorMsg",
    updateButtonLabel: "updateButtonLabel",
    cancelButtonLabel: "cancelButtonLabel",
    manualOverrideAriaLabel: "manualOverrideAriaLabel",
    invitationToEditText: "invitationToEditText",
    invitationToEditTextTextInFormEditor: "invitationToEditTextTextInFormEditor",
    noLocationSelectedText: "noLocationSelectedText",
    dependencyLoaderMessageText: "dependencyLoaderMessageText",
    dependencyLoaderMessageNamedText: "dependencyLoaderMessageNamedText",
    dependencyChangedAlertText: "dependencyChangedAlertText",
    dependencyChangedButtonLabel: "dependencyChangedButtonLabel",
    locateNowButtonLabel: "locateNowButtonLabel"
};

const MESSAGES = {
    [KEYS.latitudeLabel]: {
        value: "Latitude",
        comment: "Label for Latitude field"
    },
    [KEYS.longitudeLabel]: {
        value: "Longitude",
        comment: "Label for Longitude field"
    },
    [KEYS.longitudeMaxLengthErrorMsg]: {
        value: "Please enter a value for longitude less than or equal to 180",
        comment:
            "Validator error message for longitude when a value greater than 180 is entered. " +
            "Longitude can never have a value greater than 180."
    },
    [KEYS.longitudeMinLengthErrorMsg]: {
        value: "Please enter a value for longitude greater than or equal to -180",
        comment:
            "Validator error message for longitude when a value less than -90 is entered. " +
            "Longitude can never have a value less than -180."
    },
    [KEYS.latitudeMaxLengthErrorMsg]: {
        value: "Please enter a value for latitude less than or equal to 90",
        comment:
            "Validator error message for latitude when a value greater than 90 is entered. " +
            "Latitude can never have a value greater than 90."
    },
    [KEYS.latitudeMinLengthErrorMsg]: {
        value: "Please enter a value for latitude greater than or equal to -90",
        comment:
            "Validator error message for latitude when a value less than -90 is entered. " +
            "Latitude can never have a value less than -90."
    },
    [KEYS.longitudeLocationCompleteErrorMsg]: {
        value: "Longitude is required for a complete location.",
        comment: "Validator error message for longitude when it is empty but latitude has a value."
    },
    [KEYS.latitudeLocationCompleteErrorMsg]: {
        value: "Latitude is required for a complete location.",
        comment: "Validator error message for latitude when it is empty but longitude has a value."
    },
    [KEYS.updateButtonLabel]: {
        value: "Update",
        comment:
            "Label for the button that updates the selected location to the location chosen on the map or via manual override."
    },
    [KEYS.cancelButtonLabel]: {
        value: "Cancel",
        comment: "Label for the button that cancels location selection or manual override."
    },
    [KEYS.manualOverrideAriaLabel]: {
        value: "Manual edit",
        comment: "Aria label for the button that allows manual override of the selected location."
    },
    [KEYS.invitationToEditText]: {
        value: "Select a location on the map to get started.",
        comment:
            "Instructions to the user on how to initially interact with the map when no location has been selected. Appears in an informational alert above the map."
    },
    [KEYS.invitationToEditTextTextInFormEditor]: {
        value: "Interactive location map is enabled",
        comment:
            "Text that appears on the element when enabling the location map in the form editor to show the map is enabled."
    },
    [KEYS.noLocationSelectedText]: {
        value: "No location selected",
        comment: "Text to display when no location has been selected."
    },
    [KEYS.dependencyLoaderMessageText]: {
        value: "Further complete address to locate on map",
        comment:
            "Text that appears on the loader component blocking access to the map input when the user is expected to input address data first."
    },
    [KEYS.dependencyLoaderMessageNamedText]: {
        value: "Further complete {dependency} to locate on map",
        comment:
            "Text that appears on the loader component blocking access to the map input when the user is expected to input address data first. {dependency} is a placeholder for the name of the element with the address data."
    },
    [KEYS.dependencyChangedAlertText]: {
        value: "The address has changed and the mapped location may longer be accurate. Would you like to update the map location of this address?",
        comment:
            "Alert message that appears when the address has changed and the location could be re-geocoded to match."
    },
    [KEYS.dependencyChangedButtonLabel]: {
        value: "Update Location",
        comment: "Button label for re-geocoding the location based on the related address."
    },
    [KEYS.locateNowButtonLabel]: {
        value: "Locate Now",
        comment: "Button label for manually initiating the geocoding process."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
